import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Moment from "react-moment";
import "moment/locale/pt-br";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";

export default function EsportsFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [game] = useState("all");
  const [eventType, setEventType] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [editingPost, setEditingPost] = useState(null);

  const handleEditPost = (post) => {
    setEditingPost(post);
  };
  const handlePostUpdated = (updatedPost) => {
    setPosts(prev => prev.map(p => p._id === updatedPost._id ? updatedPost : p));
    setEditingPost(null);
  };
  const handlePostDeleted = (postId) => {
    setPosts(prev => prev.filter(p => p._id !== postId));
  };

  const games = [
    { id: "all", name: "Todos" },
    { id: "lol", name: "League of Legends" },
    { id: "csgo", name: "CS:GO / CS2" },
    { id: "valorant", name: "Valorant" },
    { id: "dota2", name: "Dota 2" },
    { id: "fortnite", name: "Fortnite" },
    { id: "fifa", name: "EA FC / FIFA" },
    { id: "cod", name: "Call of Duty" },
    { id: "rl", name: "Rocket League" },
    { id: "freefire", name: "Free Fire" },
  ];

  const eventTypes = [
    { id: "all", name: "Todos" },
    { id: "tournament", name: "Torneios" },
    { id: "match", name: "Partidas" },
    { id: "news", name: "Notícias" },
    { id: "highlights", name: "Highlights" },
  ];

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/esports?page=${pageNum}&limit=12`;
      if (game !== "all") url += `&game=${game}`;
      if (eventType !== "all") url += `&eventType=${eventType}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching esports:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [game, eventType]);

  const getStatusBadge = (status) => {
    switch (status) {
      case "live": return <span className="esports_badge live">AO VIVO</span>;
      case "upcoming": return <span className="esports_badge upcoming">EM BREVE</span>;
      case "finished": return <span className="esports_badge finished">ENCERRADO</span>;
      default: return null;
    }
  };

  if (loading && posts.length === 0) {
    return <div className="esports_feed_loading"><div className="esports_loader"></div><span>Carregando e-sports...</span></div>;
  }

  return (
    <div className="esports_feed">
      {eventTypes.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {eventTypes.map((filter) => (
              <button
                key={filter.id}
                className={`filter_btn ${eventType === filter.id ? "active" : ""}`}
                onClick={() => setEventType(filter.id)}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="esports_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M21.58 16.09l-1.09-7.66C20.21 6.46 18.52 5 16.53 5H7.47C5.48 5 3.79 6.46 3.51 8.43l-1.09 7.66C2.2 17.63 3.39 19 4.94 19h0c.68 0 1.32-.27 1.8-.75L9 16h6l2.25 2.25c.48.48 1.13.75 1.8.75h0c1.56 0 2.75-1.37 2.53-2.91zM11 11H9v2H8v-2H6v-1h2V8h1v2h2v1zm4-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/>
          </svg>
          <h3>Nenhum evento encontrado</h3>
          <p>Seja o primeiro a publicar sobre e-sports!</p>
        </div>
      ) : (
        <div className="esports_grid">
          {posts.map((post) => (
            <div key={post._id} className="esports_card">
              <div className="esports_thumbnail">
                <img src={post.esportsData?.thumbnail || post.images?.[0]?.url || post.images?.[0] || "/images/default-esports.png"} alt="" />
                {getStatusBadge(post.esportsData?.status)}
              </div>
              <div className="esports_card_content">
                <span className="esports_game_tag">{games.find(g => g.id === post.esportsData?.game)?.name || post.esportsData?.game}</span>
                <h3>{post.esportsData?.title || post.text}</h3>
                {post.esportsData?.teams && post.esportsData.teams.length >= 2 && (
                  <div className="esports_matchup">
                    <div className="esports_team">
                      <img src={post.esportsData.teams[0]?.logo || "/images/team-default.png"} alt="" />
                      <span>{post.esportsData.teams[0]?.name}</span>
                      {post.esportsData.teams[0]?.score !== undefined && (
                        <strong>{post.esportsData.teams[0].score}</strong>
                      )}
                    </div>
                    <span className="esports_vs">VS</span>
                    <div className="esports_team">
                      {post.esportsData.teams[1]?.score !== undefined && (
                        <strong>{post.esportsData.teams[1].score}</strong>
                      )}
                      <span>{post.esportsData.teams[1]?.name}</span>
                      <img src={post.esportsData.teams[1]?.logo || "/images/team-default.png"} alt="" />
                    </div>
                  </div>
                )}
                <div className="esports_meta">
                  <Link to={`/profile/${post.user.username}`} className="esports_author">
                    <img src={post.user.picture} alt="" />
                    <span>{post.user.first_name}</span>
                  </Link>
                  <span>•</span>
                  <Moment fromNow locale="pt-br">{post.createdAt}</Moment>
                </div>
                <div onClick={(e) => e.stopPropagation()}>
                  <FeedPostMenu
                    post={post}
                    onEdit={handleEditPost}
                    onPostDeleted={handlePostDeleted}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="esports_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais"}
          </button>
        </div>
      )}
      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}
    </div>
  );
}
